import BaseTracker from './BaseTracker';
import { AnalyticsUserData } from '../types';

const HOTJAR_EVENT_WHITELIST = [
  'client_booking_exit',
  'client_book_confirmation_cancel_clicked',
  'client_inactive_proprofile_viewed',
  'client_quick_availability_canceled',
  'client_procalendar_time_cancel_clicked',
  'pro_home_search_boost_viewed',
  'search_page_land',
];

export class HotjarTracker extends BaseTracker {
  constructor(env: string, platform: string) {
    super('hotjar', 'Hotjar', env, platform);
  }

  // Hotjar is currently added via Google Tag Manager and setup only for production. This shim makes
  // sure it is loaded before attempting to use the hj function throughout the application and limits
  // usage to only appropriate platforms and environments.
  hj = ((...args) => {
    if (this.env === 'production' || this.env === 'staging') {
      if (this.platform === 'web') {
        const anyWindow = window as any;
        // If there is a chance that the code will be run before the Hotjar script has loaded,
        // you must add the following line of code just before the trigger function:
        // eslint-disable-next-line
        anyWindow.hj = anyWindow.hj || function () {
          (anyWindow.hj.q = anyWindow.hj.q || []).push(arguments)
        }
        return anyWindow.hj(...args);
      }
    }
    // To facilitate testing of these calls on local, lc, stage we output what would have happened
    // if Hotjar was enabled in that environment to the console.
    // eslint-disable-next-line no-console
    return console.warn(`Hotjar called with ${args.join(' ')} in the ${this.env} environment on ${args[0]} ${this.platform} device`);
  });

  trackEvent(eventName) {
    if (HOTJAR_EVENT_WHITELIST.indexOf(eventName) >= 0) {
      this.debugLog('trigger', eventName);
      this.hj('trigger', eventName);
    }
  }

  updateUser(userData: AnalyticsUserData | null) {
    const params = {
      email: userData.email,
      is_anon: !userData.is_logged_in,
    };

    this.hj('identify', userData.is_logged_in ? userData.user_id : null, params);
  }
}
